import React, { ChangeEvent, FormEvent, useState } from "react";
import axios from 'axios';
import emailjs from 'emailjs-com';
import { useTranslation } from "react-i18next";

emailjs.init("ZSdv6q44S03CsMxDW")

type Errors = {
  phoneNumber?: string;
  email?: string;
  wechatID?: string;
};

const Form = () => {
  const { t } = useTranslation("home");

  const [formData, setFormData] = useState({
    phoneNumber: "",
    email: "",
    wechatID: "",
  });

  const [successText, setSuccessText] = useState<string>("");
  const [errors, setErrors] = useState<Errors>({});

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const validatePhoneNumber = (phoneNumber: string) => {
    return /^\d{10}$/.test(phoneNumber);
  };

  const validateEmail = (email: string) => {
    return /^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/i.test(email);
  };

  const validateWechatID = (wechatID: string) => {
    return true;
  };

  const handleSubmit = async (e: FormEvent<HTMLFormElement>) => {
    e.preventDefault();
    // Validation logic
    const newErrors: Errors = {};

    if (!validatePhoneNumber(formData.phoneNumber)) {
      newErrors.phoneNumber = "Invalid phone number format";
    }

    if (!validateEmail(formData.email)) {
      newErrors.email = "Invalid email format";
    }

    if (!validateWechatID(formData.wechatID)) {
      newErrors.wechatID = "Invalid WeChat ID format";
    }

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
    } else {
      const { phoneNumber, email } = formData;

      let msg =
        "Phone Number: " +
        phoneNumber +
        "\nEmail: " +
        email +
        "\nWeChat ID: " +
        formData.wechatID;

      emailjs
        .send("service_m6d58rf", "template_ahqp9kd", {
          to_name: "Gege",
          message: msg,
        })
        .then(
          (response) => {
            console.log("SUCCESS!", response.status, response.text);
            setSuccessText(t("form.success"));
          },
          (error) => {
            console.log("FAILED...", error);
          }
        );

      console.log("Email sent");
      //sql server stuff
      // try {
      //   const response = await axios.post('/api/submit', { username: phoneNumber, email });
      //   console.log(response.data);
      // } catch (error) {
      //   console.error(error);
      // }
    }
  };

  return (
    <form onSubmit={handleSubmit}>
      <ul className="space-y-2">
        <li>
          <input
            className={`shadow appearance-none border rounded w-4/5 py-2 px-3 text-gray-700 bg-gray-100 leading-tight focus:outline-none focus:shadow-outline ${
              errors.phoneNumber ? "border-red-500" : ""
            }`}
            name="phoneNumber"
            type="text"
            placeholder={t("form.phonePlaceholder")}
            value={formData.phoneNumber}
            onChange={handleChange}
          />
          {errors.phoneNumber && (
            <p className="text-red-500">{errors.phoneNumber}</p>
          )}
        </li>
        <li>
          <input
            className={`shadow appearance-none border rounded w-4/5 py-2 px-3 text-gray-700 bg-gray-100 leading-tight focus:outline-none focus:shadow-outline ${
              errors.email ? "border-red-500" : ""
            }`}
            name="email"
            type="text"
            placeholder={t("form.emailPlaceholder")}
            value={formData.email}
            onChange={handleChange}
          />
          {errors.email && <p className="text-red-500">{errors.email}</p>}
        </li>
        <li>
          <input
            className={`shadow appearance-none border rounded w-4/5 py-2 px-3 text-gray-700 bg-gray-100 leading-tight focus:outline-none focus:shadow-outline ${
              errors.wechatID ? "border-red-500" : ""
            }`}
            name="wechatID"
            type="text"
            placeholder={t("form.wechatPlaceholder")}
            value={formData.wechatID}
            onChange={handleChange}
          />
          {errors.wechatID && (
            <p className="text-red-500">{errors.wechatID}</p>
          )}
        </li>
        <li>
          <div className="mx-auto my-4 text-center bg-orange-400 py-1 w-4/5 rounded-full text-white">
            <button type="submit">{t("form.submit")}</button>
          </div>
        </li>
      </ul>
      <div className="text-green-500">
        <p>{successText}</p>
      </div>
    </form>
  );
};

export default Form;
